import { useEffect } from "react";
import { Box, Button } from "@material-ui/core";
import { useReactiveVar } from "@apollo/client";
import { mobileAppModel } from "../../state";
import { ContentTypeEnum } from "../../../../../generated/graphql";
import { ALLOWED_PLATFORMS_BY_TYPE, PLATFORM_LABELS } from "../../constants";

const platformKeys = Object.keys(PLATFORM_LABELS);

export const PlatformTabs = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const contentType = model?.contentType?.name;

  const activePlatform = useReactiveVar(mobileAppModel.activePlatform);

  const getIsDisabled = (platformKey: string) => {
    if (!contentType) return true;

    const allowedPlatforms = ALLOWED_PLATFORMS_BY_TYPE[contentType];

    return !allowedPlatforms?.includes(platformKey);
  };

  useEffect(() => {
    const firstEnabled = platformKeys.find((key) => !getIsDisabled(key));
    if (firstEnabled) {
      mobileAppModel.setActivePlatform(firstEnabled);
    }
  }, [contentType]);

  return (
    <Box display="flex" flexWrap="wrap" mt={2} gridGap={6} maxWidth={520}>
      {platformKeys.map((key) => {
        const disabled = getIsDisabled(key);

        return (
          <Button
            key={key}
            onClick={() => mobileAppModel.setActivePlatform(key)}
            disabled={disabled}
            variant="outlined"
            style={{
              textTransform: "none",
              border: "2px solid black",
              borderRadius: 12,
              backgroundColor: activePlatform === key ? "#ffe066" : "#ffffff",
              fontWeight: activePlatform === key ? "bold" : "normal",
              color: "black",
              marginRight: 8,
              marginBottom: 8,
              opacity: disabled ? 0.4 : 1,
            }}
          >
            {PLATFORM_LABELS[key]}
          </Button>
        );
      })}
    </Box>
  );
};
